import React, {useEffect} from "react";
import {useParams} from "react-router";
import {useLang} from "../../context/lang";

import {Card, CardHeader} from "@mui/material";
import CardContent from '@mui/material/CardContent';

import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';

import {blue, red} from '@mui/material/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Contacts= ()=> {
  const params=useParams();
const lang =useLang();

  useEffect(()=>{



  },[])
  return (
    <div className='flex-grow bg-neutral-100  p-2' >
<Card variant="outlined" className="mb-4">
  <CardHeader avatar={
    <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
   TG
    </Avatar>
  }
    action={
      <IconButton aria-label="settings">
      <a href="https://t.me/+VjaO0_aC1fgyZjNi" target="_blank"> <MoreVertIcon /></a>
      </IconButton>
    }
    title="Telegram link"
/>
  <CardContent>
    <a href="https://t.me/+VjaO0_aC1fgyZjNi" target="_blank"> {lang.lang=='en' ? "Jojn channel" : "Unirse al canal"}</a>
  </CardContent>

</Card>
      <Card variant="outlined" className="mt-4">
        <CardHeader avatar={
          <Avatar sx={{ bgcolor: blue[500] }} aria-label="recipe">
            <InstagramIcon/>
          </Avatar>
        }
                    action={
                      <IconButton aria-label="settings">
                        <a href="https://www.instagram.com/alex.poto" target="_blank"> <MoreVertIcon /></a>
                      </IconButton>
                    }
                    title="Instagram link"
        />
        <CardContent>
          <a href="https://www.instagram.com/alex.poto" target="_blank"> {lang.lang=='en' ? "Subscribe" : "Suscribirse"}</a>
        </CardContent>

      </Card>

      <Card variant="outlined" className="mt-4">
        <CardHeader avatar={
          <Avatar sx={{ bgcolor: blue[500] }} aria-label="recipe">
            <LinkedInIcon/>
          </Avatar>
        }
                    action={
                      <IconButton aria-label="settings">
                        <a href="//https://www.linkedin.com/in/facereplays/" target="_blank"> <MoreVertIcon /></a>
                      </IconButton>
                    }
                    title="LinkedIn"
        />
        <CardContent>
          <a href="//https://www.linkedin.com/in/facereplays/" target="_blank"> {lang.lang=='en' ? "Subscribe" : "Suscribirse"}</a>
        </CardContent>

      </Card>

      <div> </div>
    </div>
  );
}

export default Contacts;
